import type { FunctionComponent, ReactElement } from 'react';

import { usePortalUrl } from '../../shared/publicPortal/hooks';

type PortalUrlOnlyGateProps = {
  children: ReactElement<any, any> | null;
  alwaysShow?: boolean;
};

/**
 * Access gate which renders any children,
 * but only if the underlying FOSSA instance has a portal URL available
 *
 * @example - Button only renders if the user is using a FOSSA instance that's in the cloud:
 * <PortalUrlOnlyGate>
 *  <Button>I do something that only makes sense with a portal URL!</Button>
 * </PortalUrlOnlyGate>
 */
const PortalUrlOnlyGate: FunctionComponent<PortalUrlOnlyGateProps> = ({ children, alwaysShow }) => {
  const { url } = usePortalUrl();

  if (url === null && !alwaysShow) {
    return null;
  }
  return children;
};

export default PortalUrlOnlyGate;
